module.exports = __webpack_public_path__ + "img/Loading_32px.0bf082ef.svg";